var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable */
import React, { useRef } from 'react';
import { PopupTitle } from 'component/title/Title';
import Popover from '@material-ui/core/Popover';
import { withStyles, Dialog } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { StyledButtonCancel, StyledButtonConfirm, } from 'component/material/StyledButton';
import { HotKeys } from 'react-hotkeys';
import { ButtonContainO, ButtonContain, } from 'component/material/ButtonContained/Button';
import { useDispatch } from 'react-redux';
import { setLoadingRedux } from 'reducers/sharedata/action';
var Style = require('./PopDialog_style.module.css');
// style -------------------------------------------------------------------------------------
var StyledPopover = withStyles({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    paper: {
        // width: "300px",
        maxWidth: 'none',
        top: 0,
        left: 0,
    },
})(Popover);
// style={{ zIndex: 100, background: "rgba(0, 0, 0, 0.4)",  }}
var StyleDialog = withStyles({
    paper: {
        maxWidth: 'none',
    },
})(Dialog);
// component -------------------------------------------------------------------------------------
var PopupEditTitle = function (props) {
    return (React.createElement("div", { className: Style.listitem },
        React.createElement(PopupTitle, { title: props.title }),
        React.createElement(IconButton, { style: {
                position: 'absolute',
                right: '12px',
                top: '0px',
                color: 'white',
            }, onClick: props.handleExit },
            React.createElement(CloseIcon, null))));
};
var PopDialog = function (props) {
    var _a = props.title, title = _a === void 0 ? '系統訊息' : _a, _b = props.width, width = _b === void 0 ? '80vw' : _b, show = props.show, _c = props.escExit, escExit = _c === void 0 ? false : _c, handleExit = props.handleExit, children = props.children, _d = props.childrenStyle, childrenStyle = _d === void 0 ? {} : _d;
    return (React.createElement(StyleDialog, { open: show, disableEnforceFocus: !escExit, onClose: escExit ? handleExit : undefined },
        React.createElement(PopupEditTitle, { title: title, handleExit: handleExit }),
        React.createElement("div", { className: Style.popup_content, style: __assign({ width: width, minWidth: 200 }, childrenStyle) }, children)));
};
export default PopDialog;
export var PopMsg = function (props) {
    var dispatch = useDispatch();
    var _a = props.title, title = _a === void 0 ? '系統訊息' : _a, _b = props.width, width = _b === void 0 ? '15vw' : _b, show = props.show, _c = props.msg, msg = _c === void 0 ? '' : _c, handleExit = props.handleExit, textColor = props.textColor, _d = props.btnText, btnText = _d === void 0 ? '關閉' : _d;
    var msgPresnt = msg
        .split('\n')
        .map(function (obj, idx) { return React.createElement("div", { key: idx }, obj); });
    var funcWithLoading = function (func) { return function () {
        return (function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch(setLoadingRedux(1));
                        return [4 /*yield*/, func()];
                    case 1:
                        _a.sent();
                        dispatch(setLoadingRedux(-1));
                        return [2 /*return*/];
                }
            });
        }); })();
    }; };
    return (React.createElement(HotKeys, { keyMap: { KeyExit: ['Enter', 'Y', 'y'] }, handlers: { KeyExit: funcWithLoading(handleExit) } },
        React.createElement(PopDialog, { show: show, title: title, handleExit: funcWithLoading(handleExit), width: width, escExit: true },
            React.createElement("div", { className: Style.text, style: { color: textColor } }, msgPresnt),
            React.createElement("div", { className: Style.function_button_area },
                React.createElement(ButtonContain, { className: Style.margin2, onClick: funcWithLoading(handleExit) }, btnText)))));
};
export var PopConfirm2 = function (props) {
    var dispatch = useDispatch();
    var _a = props.title, title = _a === void 0 ? '系統訊息' : _a, _b = props.width, width = _b === void 0 ? '15vw' : _b, _c = props.btnText, btnText = _c === void 0 ? ['確認', '取消'] : _c, show = props.show, msg = props.msg, onConfirm = props.onConfirm, onExit = props.onExit, onInvalid = props.onInvalid;
    var submitBtnRef = useRef(null);
    var funcWithLoading = function (func) { return function () {
        return (function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch(setLoadingRedux(1));
                        return [4 /*yield*/, func()];
                    case 1:
                        _a.sent();
                        dispatch(setLoadingRedux(-1));
                        return [2 /*return*/];
                }
            });
        }); })();
    }; };
    return (React.createElement(HotKeys, { keyMap: {
            KeyConfirm: ['Enter', 'Y', 'y'],
            KeyReject: ['N', 'n'],
        }, handlers: {
            KeyConfirm: funcWithLoading(onConfirm),
            KeyReject: funcWithLoading(onExit),
        } },
        React.createElement(PopDialog, { show: show, title: title, handleExit: funcWithLoading(onExit), width: width, escExit: true },
            React.createElement("form", { onInvalid: onInvalid, onSubmit: function (e) {
                    e.preventDefault();
                    funcWithLoading(onConfirm)();
                } },
                React.createElement("button", { ref: submitBtnRef, type: "submit", hidden: true }, "submit"),
                React.createElement("div", { className: Style.text }, msg)),
            React.createElement("div", { className: Style.function_button_area },
                React.createElement(ButtonContainO, { className: Style.margin2, variant: "outlined", onClick: funcWithLoading(onExit) }, btnText[1]),
                React.createElement(ButtonContainO, { className: Style.margin2, onClick: function () { var _a; return (_a = submitBtnRef.current) === null || _a === void 0 ? void 0 : _a.click(); } }, btnText[0])))));
};
export var PopConfirm3 = function (props) {
    var dispatch = useDispatch();
    var _a = props.title, title = _a === void 0 ? '系統訊息' : _a, _b = props.width, width = _b === void 0 ? '25vw' : _b, show = props.show, _c = props.msg, msg = _c === void 0 ? '' : _c, escExit = props.escExit, handleConfirm = props.handleConfirm, handleReject = props.handleReject, handleExit = props.handleExit, _d = props.btnText, btnText = _d === void 0 ? ['是', '否', '取消'] : _d;
    var msgPresnt = msg
        .split('\n')
        .map(function (obj, idx) { return React.createElement("div", { key: idx }, obj); });
    var funcWithLoading = function (func) { return function () {
        return (function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch(setLoadingRedux(1));
                        return [4 /*yield*/, func()];
                    case 1:
                        _a.sent();
                        dispatch(setLoadingRedux(-1));
                        return [2 /*return*/];
                }
            });
        }); })();
    }; };
    return (React.createElement(HotKeys, { keyMap: {
            KeyConfirm: ['Y', 'y'],
            KeyReject: ['N', 'n'],
        }, handlers: {
            KeyConfirm: funcWithLoading(handleConfirm),
            KeyReject: funcWithLoading(handleReject),
        } },
        React.createElement(PopDialog, { show: show, title: title, handleExit: funcWithLoading(handleExit), width: width, escExit: true },
            React.createElement("div", { className: Style.text }, msgPresnt),
            React.createElement("div", { className: Style.function_button_area },
                React.createElement(StyledButtonConfirm, { className: Style.margin2, onClick: funcWithLoading(handleConfirm) }, btnText[0]),
                React.createElement(StyledButtonConfirm, { className: Style.margin2, onClick: funcWithLoading(handleReject) }, btnText[1]),
                React.createElement(StyledButtonCancel, { className: Style.margin2, onClick: funcWithLoading(handleExit) }, btnText[2])))));
};
// function ------------------------------------------------
export var popObjToggle = function (setConfig, show) {
    setConfig(function (prev) { return (__assign(__assign({}, prev), { show: show === undefined ? !prev.show : show })); });
};
